import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";

const CommentReplyInteraction = ({
  isOwnedPost,
  item,
  commentId,
  AllPostList,
  updateComment,
  handleReplySave,
  handleReplyEdit,
  setEditedReply,
  setRplyCmntId,
  isReplyEditing,
  editedReply,
  postId,
  setPostList,
  postList
}) => {
  console.log("replydelete", item);
  const sessionId = localStorage.getItem("sessionId");
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const language = localStorage.getItem("Lang");

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  //************************Delete Post start  ************************//
  const [show, setShow] = useState(false);
  const handleDeleteClose = () => {
    setShow(false);
  };
 
  const deleteCommentReply = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: item.pstCmntRplyId,
            langKey: language === "en" ? "" : language,

    };
    const scrollY = window.scrollY;

    try {
      const res = await axios.post(`PostAction/DeleteCommentReply`, responseData);
      setShow(false);
      setToastMessage(res.data.message);
      setShowToast(true);

      const updatedPostList = postList.map((post) => {
        if (post?.postInfo?.postId === postId) {
          const updatedComments = post?.postInfo?.comments.map((comment) => {
            if (comment?.pstCmntId === commentId) {
              const updatedReplies = comment.commentsReplies.filter(
                (reply) => reply.pstCmntRplyId !== item.pstCmntRplyId
              );
  
              return {
                ...comment,
                commentsReplies: updatedReplies,
                replyCount: comment.replyCount - 1,
              };
            }
            return comment;
          });
  
          return {
            ...post,
            postInfo: {
              ...post.postInfo,
              comments: updatedComments,
            }
          };
        }
        return post;
      });
  
      setPostList(updatedPostList);
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });

    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(null);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //************************Delete Post End  ************************//

  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show]);
  return (
    <>
      {(item?.isOwned || isOwnedPost) ? (
        <div
          className={`postMenu pointer commentInteraction${showDropdown ? " is-open" : ""}`}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <MoreHorizSharpIcon className="material-symbols-sharp" />
          {showDropdown && (
            <Dropdown.Menu
              show={showDropdown}
              ref={dropdownRef}
              className="InteractionModal wlj-company-action-menu"
              onClick={(event) => event.stopPropagation()}
            >
              {(item?.isOwned || isOwnedPost) && (
                <Dropdown.Item 
                  as="button" 
                  className="dropdownList"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShow(!show);
                    toggleDropdown();
                  }}
                >
                  <div>
                    <div className="d-flex align-items-center">
                      <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt f-14 redText">{t("Drafts.Delete")}</span>
                    </div>
                    <p className="f-12 dropdownPara">
                      {t("Drafts.Once Deleted it can't be recovered")}
                    </p>
                  </div>
                </Dropdown.Item>
              )}
              {item?.isOwned && (
                <Dropdown.Item 
                  as="button" 
                  className="dropdownList"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleReplyEdit();
                    toggleDropdown();
                  }}
                >
                  <div>
                    <div className="d-flex align-items-center">
                      <EditSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt f-14">{t("Drafts.Edit")}</span>
                    </div>
                    <p className="f-12 dropdownPara">{t("Drafts.Edit Comment")}</p>
                  </div>
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          )}
        </div>
      ) : (
        ""
      )}

      {/* <Modal
        show={show}
        size="md"
        centered
        onHide={handleDeleteClose}
        toggle={() => setShow(!show)}
      // className='modal-dialog-centered m'
      >
        <Modal.Header
          className="bg-transparent p-4"
          closeButton
          toggle={() => {
            setShow(!show);
          }}
        >
          <h6 className="f-16 fw-bold wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  Are you sure you want to delete comment Reply?
                </h6>
        </Modal.Header>
        <Modal.Body className="text-center">
          <button
            color=""
            className="closebtn"
            onClick={() => deleteCommentReply()}
          >
            Delete
          </button>
        </Modal.Body>
      </Modal> */}

      {show && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  {t("User Profile.Are You Sure You want to Delete?")}
                </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <button
                  type="button"
                  className="closebtn "

                  onClick={() => deleteCommentReply()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CommentReplyInteraction;
